import React from 'react';
import FontAwesomeAPM from './FontAwesomeAPM';

var Icon = props => /*#__PURE__*/React.createElement(FontAwesomeAPM, props);

Icon.displayName = "Icon";
Icon.displayName = 'Icon';
export default Icon;